import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { MatDialog } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';
import { GroupRoleSelectionComponent } from './group-role-selection/group-role-selection.component';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { GroupService } from '@services/groups/group.service';

@Component({
    selector: 'app-group-roles-manager',
    templateUrl: './group-roles-manager.component.html',
    styleUrls: ['./group-roles-manager.component.scss'],
    providers: [GroupHasRoleInOrganisationService, GroupService],
    standalone: false
})
export class GroupRolesManagerComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  title = 'Group Role Management';
  dataProviderParams: any;
  pageActions: PageAction[];
  columns = [{ prop: 'roleName' }, { prop: 'organisationTitle' }];

  selectedGroupId: string;

  constructor(
    public groupHasRolesInOrganisationsService: GroupHasRoleInOrganisationService, private route: ActivatedRoute, private router: Router, private dialog: MatDialog,
    private groupService: GroupService
  ) {
  }

  ngOnInit() {
    this.selectedGroupId = this.route.snapshot.params['id'];
    this.dataProviderParams = { GroupID: this.selectedGroupId };
    this.createPageActions();
    this.groupService.get(this.selectedGroupId).then(group => {
      this.title = !!group ? 'Manage Roles of Group: ' + group.name : this.title;
    });
  }

  addRole() {
    const dialogRef = this.dialog.open(GroupRoleSelectionComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else if (!result.OrganisationID || !result.RoleID) {
        console.error('could not add role, because of insufficient data');
        return;
      }
      const data = new Models.GroupHasRoleInOrganisation();
      data.populateFromJSON({
        ID: undefined,
        GroupID: this.selectedGroupId,
        OrganisationID: result.OrganisationID,
        RoleID: result.RoleID
      });
      this.groupHasRolesInOrganisationsService.create(data).then(() => {
        this.table.refresh();
      });
    });
  }

  onDelete(event: any) {
    this.groupHasRolesInOrganisationsService.remove(event.row.ID).then(result => {
      this.ngOnInit();
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Detail',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id']]);
        }
      })
    ];
  }

}
